import { LiaMapMarkerAltSolid } from "react-icons/lia";

export const MapIcon = ({ ...rest }) => {
  return <LiaMapMarkerAltSolid {...rest} />;
};
